// Staking-token (V2) pool duration types.
// The `type` field on the `staking-token` API maps to a lock-duration tier.
export enum StakingTokenTypeEnum {
  TYPE_3M = 1,
  TYPE_6M = 2,
  TYPE_12M = 3,
}

// Label + gradient (Tailwind arbitrary value) per duration tier.
export const STAKING_TOKEN_TYPE_LABEL = [
  {
    label: '3 Months',
    value: StakingTokenTypeEnum.TYPE_3M,
    labelClassName:
      'bg-[linear-gradient(134deg,rgba(0,71,255,0.75)_0%,rgba(0,188,212,0.5)_100%)]',
  },
  {
    label: '6 Months',
    value: StakingTokenTypeEnum.TYPE_6M,
    labelClassName:
      'bg-[linear-gradient(134deg,rgb(0,71,255)_0%,rgba(0,71,255,0)_100%)]',
  },
  {
    label: '12 Months',
    value: StakingTokenTypeEnum.TYPE_12M,
    labelClassName:
      'bg-[linear-gradient(134deg,rgba(123,0,255,1)_0%,rgba(128,120,207,0.471188)_52.88%,rgba(0,71,255,0)_100%)]',
  },
];

export const getStakingTokenTypeLabel = (type?: number) =>
  STAKING_TOKEN_TYPE_LABEL.find((item) => item.value === type);
